import React, { Component, useEffect, useState } from 'react';
import RegisterEmailView from './RegisterEmailView';
import ReceiveMarketingEmailView from './ReceiveMarketingEmailView'
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import crmServices from '../../wsclient/'
import t from '../../utils/translateUtil';
import ModalAlert from '../../components/ModalAlert'
import Loading from '../../components/Loading'
import { getAppCfg, getBrowser, getCountries, getOrderingCountries, getCountryDefault, getRejectTriggerContact, getSupportOrderLocation, setContacts, setSupportOrderContact, getCountryDefaultByCode, getLanguage, getData } from '../../utils/common'
import { Grid } from '@material-ui/core';
import { LinkCTA, LinkInLine, LinkRouter } from '../../components/Link';
import { countries_agreement } from '../../../portal.menu.config';
import { isThisHour } from 'date-fns/esm';
import { isThisSecond } from 'date-fns';
import RegisterVerificationView from '../register/RegisterVerificationView';
import { dataUtil } from '../../wsclient/crmservices/dataUtil';
import { paths } from '../../../portal.router.config';
import { connection, domainName, portal_config } from '../../../portal.config';
import crmservices from '../../wsclient/';
import { order_key, setOrderCache } from '../../utils/order_cache';
import TermAndConditionsView from '../more-info/TermAndConditionsView';
import PrivacyPolicyView from '../more-info/PrivacyPolicyView';
import { googleAnalytics, eventTypeSimple } from '../../intergrations/google.analytics';
const styles = theme => ({

});
function RegisterEmail(props) {
    const config = getAppCfg()
    const about_details = config && config.about_details ? config && config.about_details: {};
    let agreement_countries = getCountries();
    let orderCountries = getOrderingCountries();
    let country_default = null;
    if (connection.crmConfig.useOrderCountry) {
        if(orderCountries.length == 1){ 
            country_default = connection.crmConfig.defaultCountry ? connection.crmConfig.defaultCountry : orderCountries[0].value;
        }else if(orderCountries.length > 1){
            if(connection.crmConfig.defaultCountry){
                let existCountry = orderCountries.filter(x => x.value === connection.crmConfig.defaultCountry);
                if(existCountry && existCountry.length > 0){
                    country_default = existCountry[0].value;
                }
            }
        }
    } else {
        let configAgreement_countries = config && config.contact && config.contact.agreement_countries ? config.contact.agreement_countries : null
        country_default = getCountryDefault(configAgreement_countries) ? getCountryDefault(configAgreement_countries).value : null
    }

    const [active, setActive] = useState('main');
    const [error, setError] = useState({});
    const [showLoading, onShowLoading] = useState(false);
    const [register_info, setRegisterInfo] = useState({
        email_opt_out: false,
        sms_opt_out: false,
        country_agreement: country_default
    });
    const [auth_otp, setAuthOtp] = useState(null);
    const [obfuscated_value, setObfuscatedValue] = useState(null);
    const [validation, setValiadation] = useState({});
    const [countDown, setCountDown] = useState('');
    const [timer_otp, setTimeOTP] = useState({});
    const [accept_policy, setAcceptPolicy] = useState(false);
    const [redirect, setRedirect] = useState(null);
    const [drawer, setDrawer] = useState({});
    const auth_support = config && config.auth_support ? config.auth_support : { facebook: false, google: false };
    const requestTimer = 30;

    const onSelectCountry = (values) => {
        setRegisterInfo(prevState => ({
            ...prevState,
            country_agreement: values.target.value
        }));
    }
    const onRegister = async (values) => {
        let isValid = onValidateCountry(values);
        let language_code = getLanguage();
        if (isValid) {
            let temp_register_info = { ...register_info }
            setRegisterInfo(prevState => ({
                ...prevState,
                first_name: values.first_name,
                last_name: values.last_name,
                username: values.username,
                password: values.password,
                referral_code: values.referral_code
            }));
            temp_register_info.first_name = values.first_name;
            temp_register_info.last_name = values.last_name;
            temp_register_info.username = values.username;
            temp_register_info.password = values.password;
            temp_register_info.referral_code = values.referral_code;
            console.log('temp_register_info:', temp_register_info);
            if (values.password !== values.confirm_password) {
                showAlert(t('ERROR'), t('ENTER_THE_SAME_PASSWORD'));
                return
            }
            onShowLoading(true);
            let appConfig = getAppCfg();
            let isEmailOtp = appConfig && appConfig.auth_support && appConfig.auth_support.email_otp;
            try {
                let validation_required = appConfig.auth_support && appConfig.auth_support.email_verification ? true : false;
                if (isEmailOtp)
                    validation_required = undefined;

                let result = await crmServices.contacts.registerByEmail({ ...temp_register_info, validation_required: validation_required,language_code });
                //console.log('onRegister result====', result)
                if (result.code == 'OK') {
                    googleAnalytics.sendLogEvents(eventTypeSimple.sign_up, { method: 'email'})
                    if (validation_required) {
                        showAlert('SUCCESS', t('REGISTER_EMAIL_SUCCESS'), null, "/login", true);
                    } else if (isEmailOtp) {
                        setActive('verify');
                        setAuthOtp(result.data.auth_otp);
                        setObfuscatedValue(result.data.obfuscated_value);
                    } else {
                        if (result.data.access_token) {
                            await crmServices.startSession(result.data);
                            //crmServices.contacts.addApplicationUsage(appConfig.id,getBrowser().toUpperCase());
                            await checkTriggerFavouriteStore(config)
                            //props.history.push('/home');
                        } else {
                            showAlert('SUCCESS', t('REGISTER_EMAIL_SUCCESS'));
                        }
                    }
                    //this.props.history.push('/login');
                } else if (result.code === 'REGISTRATION_FAIL_CONTACT_EXISTS' || result.code === 'CIMALREADYEXISTSFORANOTHERCONTACTEXCEPTION') {
                    showAlert('ERROR', t('REGISTRATION_FAIL_CONTACT_EXISTS_EMAIL'));
                } else if (result.code === 'INVALID_PASSWORD_EXCEPTION') {
                    showAlert('ERROR', t('INVALID_PASSWORD_EXCEPTION'));
                } else if (result.code === 'PASSWORD_LENGTH_EXCEPTION') {
                    showAlert('ERROR', t('PASSWORD_LENGTH_EXCEPTION'));
                } else if (result.code === 'INVALID_CONTACTPASSWORD_EXCEPTION') {
                    showAlert('ERROR', t('INVALID_CONTACTPASSWORD_EXCEPTION'));
                } else {
                    showAlert('ERROR', t(result.code));
                }
            } catch (error) {
                console.log("register by email exception:", error);
                showAlert('ERROR', t('EXCEPTION_PROCESS'))
            }
            onShowLoading(false);
        }
    }
    const checkTriggerFavouriteStore = async (appConfig) => {

        // console.log('checkTriggerFavouriteStore router=',router)
        if (!portal_config[domainName].triggerCheckFavouriteStore) {
            // console.log('checkTriggerFavouriteStore route2r=',router)
            onShowLoading(false);
            props.history.push(paths.home);
        } else {
            try {
                var result = await crmservices.contacts.getContactPreferences();
                if (result.code == "OK") {
                    var favouriteStores = result.data && result.data.organisations ? result.data.organisations : [];
                    setOrderCache(order_key.order_favourite_shop, favouriteStores);
                    if (favouriteStores.length == 0) {
                        var result = await crmservices.contacts.getContact();
                        if (result.code === "OK") {
                            setContacts(result.data);
                        }
                        onShowLoading(false);
                        props.history.push(paths.favourite_store);
                    } else {
                        onShowLoading(false);
                        props.history.push(paths.home);
                    }
                } else {
                    onShowLoading(false);
                    props.history.push(paths.home);
                }
            } catch (error) {
                console.log("get preferences exception:", error);
                onShowLoading(false);
                props.history.push(paths.home);
            }
        }
    }
    const onVerifyOTP = async (code) => {
        onShowLoading(true);
        try {
            let config = getAppCfg();
            let result = await crmServices.contacts.validateOTP({ phone: null, auth_otp: auth_otp, otp: code.verification_code });
            if (result.code === 'OK') {
                //crmServices.contacts.addApplicationUsage(config.id,getBrowser().toUpperCase());
                onShowLoading(false);
                setActive('receive_marketing');
                if (!getSupportOrderLocation() && !getRejectTriggerContact()) {

                    let ordering_countries = []
                    if (config.features && config.features.ordering && config.features.ordering_details && config.features.ordering_details.ordering_countries) {
                        ordering_countries = config.features.ordering_details.ordering_countries
                    }
                    let isAllowOrder = await dataUtil.checkAllowOrderByContact(ordering_countries);
                    if (isAllowOrder) {
                        setSupportOrderContact(true)
                    }
                }
                await checkTriggerFavouriteStore(config)
                //props.history.push('/home');
            } else {
                showAlert('ERROR', t('INVALID_OTP'))
            }
        } catch (error) {
            showAlert('ERROR', t('EXCEPTION_PROCESS'))
        }
        onShowLoading(false);
    }
    const onResendCode = async () => {
        onShowLoading(true);
        try {
            let startSession = false;
            let result = await crmServices.contacts.authenticateEmail({ username: register_info['username'] }, startSession);
            //console.log("AAAAAAA result:",result);
            if (result.code === 'OK') {
                if (result.data && result.data.auth_otp) {
                    setAuthOtp(result.data.auth_otp);
                }
                showAlert('SUCCESS', t('OTP_RESEND_EMAIL_SUCCESS'), t('OTP'))
                // this.beginCountDown();
            } else {
                showAlert('ERROR', t('EXCEPTION_PROCESS'), t('OTP'))
            }
        } catch (error) {
            showAlert('ERROR', t('EXCEPTION_PROCESS'), t('OTP'))
        }
        onShowLoading(false);
    }
    const onReceiveMarketing = (target, value) => {
        setRegisterInfo(prevState => ({
            ...prevState,
            [target]: value
        }));
    }
    const showAlert = (status, message, title, redirect, children) => {
        onShowLoading(false);
        setRedirect(redirect);
        setError({
            showAlert: true,
            title: title,
            message: message,
            status: status,
            children: children
        });
    }
    const onCloseAlert = () => {
        if (redirect === '/login') {
            props.history.push('/login');
        }
        onShowLoading(false);
        setError({
            showAlert: false,
            title: '',
            message: '',
            status: '',
        });
    }
    const onChangeCheckboxPolicy = () => {
        setAcceptPolicy(!accept_policy);
    }
    const onResendVerification = async () => {
        //console.log(' login_info===',login_info)
        if (!register_info && !register_info.username) {
            return;
        }
        onShowLoading(true);

        try {
            let result = await crmServices.contacts.sendEmailVerification(register_info.username);
            //console.log("AAAAAAA result:",result);
            if (result.code === 'OK') {
                showAlert('SUCCESS', t('RESEND_EMAIL_SUCCESS'), t('OTP'), '/login')
            } else if (result.code == 'TOO_MANY_REQUESTS') {
                showAlert(t('ERROR'), t('TOO_MANY_REQUESTS'));
            } else if (result.code == 'TOO_MANY_RECIPIENTS_EXCEPTION') {
                showAlert(t('ERROR'), t('TOO_MANY_RECIPIENTS_EXCEPTION'));
            } else {
                showAlert('ERROR', t('EXCEPTION_PROCESS'), t('OTP'))
            }
        } catch (error) {
            showAlert('ERROR', t('EXCEPTION_PROCESS'), t('OTP'))
        }
        onShowLoading(false)
    }
    const renderPage = (active) => {
        // console.log('RegisterEmail accept_policy==',accept_policy)
        if (active === 'main')
            return (
                <RegisterEmailView
                    onSubmit={onRegister}
                    showAlert={showAlert}
                    onShowLoading={onShowLoading}
                    onReceiveMarketing={onReceiveMarketing}
                    register_info={register_info}
                    auth_support={auth_support}
                    country_default={country_default}
                    onSelectCountry={onSelectCountry}
                    onChangeCheckboxPolicy={onChangeCheckboxPolicy}
                    accept_policy={accept_policy} 
                    onShowDrawer={onShowDrawer}
                />
            )
        else if (active === 'verify')
            return (
                <RegisterVerificationView
                    onSubmit={onVerifyOTP}
                    onResend={onResendCode}
                    obfuscated_value={obfuscated_value}
                    countDown={countDown} />
            )

    }
    const onValidateCountry = () => {
        let valid = true;
        if (domainName === 'ayna') {
            if (!register_info.country_agreement) {
                valid = false;
                showAlert(true, t('please_select_country'), t('ERROR'));
            }
        }
        return valid;
    }
    const onShowDrawer = (target) => {
        let terms_conditions = about_details && about_details.terms_conditions ? about_details.terms_conditions : null;
        let privacy_policy = about_details && about_details.privacy_policy ? about_details.privacy_policy : null;

        if(target === 'terms_conditions'){
            if(terms_conditions && terms_conditions.url){
                window.open(terms_conditions.url, "_blank");
            }else{
                setDrawer({
                    ...drawer,
                    [target]: true,
                });
            }
        }else if(target === 'privacy_policy'){
            if(privacy_policy && privacy_policy.url){
                window.open(privacy_policy.url, "_blank");
            }else{
                setDrawer({
                    ...drawer,
                    [target]: true,
                });
            }
        } else if(target === 'refund_policy'){
            if(document._portalConfig.refundPolicyUrl)
                window.open(document._portalConfig.refundPolicyUrl, "_blank");
        }
    }
    let page = renderPage(active);
    return (
        <div>
            {page}
            <ModalAlert
                open={error.showAlert}
                onClose={onCloseAlert}
                hideHeader={true}
                message={error.message}
                error={error.status}
                title={error.title}
                children={error.children && <Grid xs={12} item container justify='center' style={{ marginTop: 16 }}>
                    <LinkCTA color='primary' underline
                        onClick={onResendVerification}>
                        {t('resend_verification_email')}
                    </LinkCTA>
                </Grid>
                }
            />
            {drawer && drawer.terms_conditions && 
                <TermAndConditionsView
                    open={drawer.terms_conditions}
                    onCloseItem={() => setDrawer({})}
                    about_details={about_details}  
            />}
            {drawer && drawer.privacy_policy && 
                <PrivacyPolicyView
                    open={drawer.privacy_policy}
                    onCloseItem={() => setDrawer({})}
                    about_details={about_details}
            />}
            {showLoading && <Loading showLoading={showLoading} />}
        </div>

    );
}
export default withStyles(styles)(withTranslation()(RegisterEmail));